import { Box } from "@mui/material";
import { Typography } from "@platform/design-system";

import type { FieldComponentProps } from "@platform/design-system";

const Row = ({
  label,
  value,
}: {
  label: string;
  value: string | number;
}): React.JSX.Element => (
  <Box component="tr">
    <Box component="td" sx={{ py: 1, pr: 10 }}>
      <Typography variant="body-medium">
        <strong>{label}</strong>
      </Typography>
    </Box>
    <Box component="td" sx={{ py: 1 }}>
      <Typography variant="body-medium">{value}</Typography>
    </Box>
  </Box>
);

const ContractedCarrier = ({
  field,
  methods,
}: FieldComponentProps<"contractedCarrier">): React.JSX.Element => {
  const { getValues } = methods;
  const isContractedCarrier = getValues(field.name) as boolean;
  return (
    <Box component="table">
      <Box component="tbody">
        <Row
          label="Contracted Carrier"
          value={isContractedCarrier ? "Yes" : "No"}
        />
      </Box>
    </Box>
  );
};

export { ContractedCarrier };
